
import { Helmet } from 'react-helmet-async';
// import Header from '../GlobalComponents/Funtion-Header/Header';
import TableView from '../GlobalComponents/TableView/TableView';
import React, { useEffect, useState } from 'react';
import Loader from '../GlobalComponents/Loader/Loader';
import apiMiddleware from '../Utility/middleware';
import { IoEye } from "react-icons/io5";
import { Link } from 'react-router-dom';
import Header from '../GlobalComponents/Funtion-Header/Header';
import ExcelDownload from '../GlobalComponents/Download/ExelDownload';
import PDFDownload from '../GlobalComponents/Download/PDFDownload';
import MaintenancePopup from '../GlobalComponents/Shedule-Maintanc/MaintannacePoup';
import AlertPopUP from '../GlobalComponents/Shedule-Maintanc/AlertPopUP';
import schedulePingRequest from '../Utility/Sheduler';
import ConfirmDialog from'../GlobalComponents/Alert/ConfirmDailog';
import { format } from 'date-fns';
import { SiStatuspal } from "react-icons/si";
import axios from 'axios';
import TimeConverter from '../GlobalComponents/UAETIMECONVERT/TimeConvert';
import DevicesGet from '../Utility/DevicesGet';
// Define headers with custom render functions for dynamic display
import { useNavigate } from "react-router-dom";


const headers = [

  {
    key: 'DEVICE_STATUS',
    label: 'Status',
    render: (row) => (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${row.DEVICE_STATUS === '1' ? 'bg-green-500' :
          row.DEVICE_STATUS === '0' ? 'bg-red-500' :
            row.DEVICE_STATUS === 'Delayed' ? 'bg-yellow-500' : 'bg-gray-500'
          } text-white`}

        title={row.DEVICE_STATUS === '1' ? 'ONLINE' : 'OFFLINE'}
      >
        <p className={`hidden`}>
          {row.DEVICE_STATUS === '1' ? 'ONLINE' : 'OFFLINE'}
        </p>
      </span>
    ),
  },
  {
    key: 'Status',
    label: 'Status',
    render: (row) => (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${row.Status === 'Active' ? 'bg-green-500' :
          row.Status === '0' ? 'bg-red-500' :
            row.Status === 'Delayed' ? 'bg-yellow-500' : 'bg-gray-500'
          } text-white`}

        title={row.Status === 'Active' ? 'ONLINE' : 'OFFLINE'}
      >
        <p className={`hidden`}>
          {row.Status === 'Active' ? 'ONLINE' : 'OFFLINE'}
        </p>
      </span>
    ),
  },
  { key: 'ROOM_NAME', label: 'ROOM NAME' },
  { key: 'HOST_IP', label: 'IP Address' },
  { key: 'TYPE', label: 'DEVICE TYPE' },
  { key: 'MANUFACTURE', label: 'MANUFACTURER' },
  { key: 'MODEL', label: 'MODEL' },
  { key: 'DEVICE_NAME', label: 'DEVICE NAME' }
];




const PDUheader =[

//   {
//     key: 'View',
//     label: <IoEye size={25}/>,
//     render: (row) => (
//         <Link to={`/maintenance-schedules/${row.ip_address}`}>
//          <IoEye size={25}/>
//          <p className=' hidden'>{row.ip_address}</p>
//          </Link>
//     ),
// },
{
  key: 'health',
  label: <SiStatuspal size={25}/>,
  render: (row) => (
    <span
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${row.health.overall === 'Good' ? 'bg-green-500' :
        row.health.overall === 'Critical' ? 'bg-red-500' :
          row.health.overall === 'Warning' ? 'bg-yellow-500' : 'bg-gray-500'
        } text-white`}

      title={`${row.health.overall} || ${row.health.connectivity_explanation}`}
    >
      <p className={`hidden`}>
        {row.health.overall}
      </p>
    </span>
  ),
},
{ key: 'ip_address', label: 'IP Address'},
// {
//   label: 'Last Ping',
//   key: 'ping_response',
// },
  { key: 'model', label: 'Model Name'},
 
  { key: 'location', label: 'Device Location'
  },
  { key: 'description', label: 'Description'},
  { key: 'manufacturer', label: 'Manufacturer'},
  { key: 'caption', label: 'Room Name'},
 

]


const AVheader = [
//   {
//     key: 'View',
//     label: <IoEye size={25}/>,
//     render: (row) => (
//         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
//          <IoEye size={25}/>
//          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
//          </Link>
//     ),
// },
{
  key: 'Status',
  label: <SiStatuspal size={25}/>,
  render: (row) => {
    const statusClass =
      row.Status === 'Active' ? 'bg-green-500' :
      row.Status === 'Missing' ? 'bg-red-500' :
      'bg-gray-400'; // Default class if the status doesn't match any condition

    return (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${statusClass} text-white`}
        title={row.Status}
      >
        <p className="hidden">
          {row.Status === 'Active' ? 'ONLINE' : 'OFFLINE'}
        </p>
      </span>
    );
  },
},
{ key: 'NetworkSettings',
  label: 'IP Address',
 
  render: (row) => (
    <span className="">
      {row.NetworkSettings.IPAddress}
    </span>
  )
  },
  // {
  //   label: 'Last Ping',
  //   key: 'ping_response',
  // },
  {
    key: 'ControllerName', label: 'Controller Name'
  },
  {
    key: 'RoomId', label: 'Room ID'
  },
  {
    key: 'ControllerType', label: 'Controller Type'
  },
  {
    key: 'ModelName', label: 'Model Name'
  },


]










/// PDF and XEL EXPORT settings Headers

/// PDF and XEL EXPORT settings Headers

const AVPDFheader = [
  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'Status',
    label: 'Device Status'
  },
  { key: 'NetworkSettings.IPAddress',
    label: 'IP Address',
    },
    {
      key: 'ControllerName', label: 'Controller Name'
    },
    {
      key: 'RoomId', label: 'Room ID'
    },
    {
      key: 'ControllerType', label: 'Controller Type'
    },
    {
      key: 'ModelName', label: 'Model Name'
    },
  
  
  ]


  const PDUPDFheader =[

    //   {
    //     key: 'View',
    //     label: <IoEye size={25}/>,
    //     render: (row) => (
    //         <Link to={`/maintenance-schedules/${row.ip_address}`}>
    //          <IoEye size={25}/>
    //          <p className=' hidden'>{row.ip_address}</p>
    //          </Link>
    //     ),
    // },
    {
      key: 'health.overall',
      label:'Health'
    },
    { key: 'ip_address', label: 'IP Address'},
      { key: 'model', label: 'Model'},
     
      { key: 'location', label: 'Device Location'},
      { key: 'description', label: 'Description'},
      { key: 'manufacturer', label: 'Manufacturer'},
      { key: 'caption', label: 'Room Name'},
     
    
    ]





const Devices = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [MaintanceData, setMaintanceData] = useState([]);
  const [selecteFilter, setSelecteFilter] = useState('av');
  const [isOpen, setIsOpen] = useState(false);
  const [SearchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [Heading, setHeading] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [AlertData, setAlertData] = useState([]);



  // console.log(MaintanceData)
 const navigate = useNavigate();


  useEffect(() => {
    setLoading(true);



    const handleCrudOperation = async () => {
      const body = {
        queryType: 'custom-query',
        table: 'DevicesPing_Log',
        data: {
          query: "SELECT * FROM DevicesPing_Log"
        }
      };

      try {
        const response = await apiMiddleware('POST', body);
        if (response.success) {
          // Sort the results
       
    
          setMaintanceData(response.data);

        } else {
          console.error('CRUD Operation Failed:', response.error);
        }
      } catch (error) {
        console.error('Error during CRUD operation:', error);
      } finally {
        setLoading(false); // Ensure loading is set to false after operation
      }
    };

    handleCrudOperation();
    fetchDevicesdata();


    // Optional cleanup function if needed
    return () => {
      // Cleanup code if necessary
    };
  }, [AlertData]);




  const [pduData, setPduData] = useState([]);
  const [avData, setAvData] = useState([]);
  const [smartSwitchData, setSmartSwitchData] = useState([]);







  const fetchDevicesdata = async () => {
    setLoading(true);
    try {
      // Headers for each API
      const AVdevice = await DevicesGet("/AV");

      if (AVdevice.success === false) {
        console.error("Failed to fetch device data:", AVdevice.error);
        return;
      }


      const PDUevice = await DevicesGet("/PDU");

      if (PDUevice.success === false) {
        console.error("Failed to fetch device data:", PDUevice.error);
        return;
      }



      // Update the respective states with the data

// Merge maintainestate data into avstate
//  AVdevice.Controllers.forEach(controller => {
//   // Find matching maintainestate entry
//   const match = MaintanceData
//       .filter(device => device.device_id == controller.ControllerId && device.device_ip == controller.NetworkSettings.IPAddress)
//       .pop(); // Get the latest match

//   if (match) {
//       controller.Device_status = match.Device_status;
//       controller.ping_response = match.ping_response;
//   }
// });




      

// // Merge maintainestate data into avstate
//  PDUevice.pdus.forEach(controller => {
//   // Find matching maintainestate entry
//   const match = MaintanceData
//       .filter(device => device.device_id == controller.id && device.device_ip == controller.ip_address)
//       .pop(); // Get the latest match

//   if (match) {
//       controller.Device_status = match.Device_status;
//       controller.ping_response = match.ping_response;
//   }
// });





      setPduData(PDUevice.pdus);
      setAvData(AVdevice.Controllers);


      // setSmartSwitchData(smartSwitchResponse.data);
    } catch (err) {
      console.error('Error fetching data:', err);
      // setError(err);
    } finally {
      setLoading(false);
    }
  };




  // console.log(selecteFilter);



  const handleRunSelfDiagnostics = () => {
    setHeading('Self Diagnostics');
    setIsOpen(true)


  }


  const handleRunMaintenance = (data) => {
    setHeading('Maintenance')
    setIsOpen(true)



  };


  const handleonDeviceSelect = (selectedData) => {
    setSelecteFilter(selectedData);

  };



  const SheduledProcessDateTime = async (date, actionType) => {



    // First, install date-fns
    // npm install date-fns


    const formattedDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');








    if (actionType === 'run') {
      // const body = {
      //   "route": "http://localhost:3500/api/ping/batch",
      //   "headers": {

      //   },
      //   "body": {
      //     "ips": selectedRows.map((data) => data.HOST_IP),
      //     "numPings": 4
      //   },
      //   "run_at": formattedDate
      // }

      // ;

      // const response = await apiMiddleware('/scheduler/schedule', 'POST', body);

      // if (response.success) {

      //   console.log(response);
      //   setShowAlert(true);

      // } else {
      //   console.error('CRUD Operation Failed:', response.error);
      // }





      let ips;


      if (selecteFilter === 'av') {
        ips = selectedRows.map((data) => data.NetworkSettings.IPAddress);

      }
      else if (selecteFilter === 'pdu') {
        ips = selectedRows.map((data) => data.ip_address);

      }
      else if (selecteFilter === 'network') {
        ips = selectedRows.map((data) => data);

      }






      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, formattedDate)
        .then(data => {



          const handleUpdate = async () => {
            // Extract HOST_IP values from State
            const hostIps = selectedRows.map((row) => row.HOST_IP); // Assuming State is an array of objects

            // Create a dynamic SQL query
            const query = `
                    UPDATE DEVICE_TBL
                    SET SHEDULE_PING_STATUS = 'Scheduled'
                    WHERE HOST_IP IN (${ips.map((ip) => `'${ip}'`).join(', ')})
                `;

            const body = {
              queryType: 'custom-query',
              table: 'DEVICE_TBL',
              data: {
                query: query,
              },
            };


            try {
              const response = await apiMiddleware('POST', body);
              // if (response.success) {
              //     console.log('Update successful:', response.data);
              // } else {
              //     console.error('CRUD Operation Failed:', response.error);
              // }
            } catch (error) {
              console.error('Error during CRUD operation:', error);
            } finally {
              setLoading(false); // Ensure loading is set to false after operation
            }
          };




          // handleUpdate();



          const insertDataIntoNotificationTbl = async () => {
            if (!selectedRows || selectedRows.length === 0) {
              console.error("No data to insert.");
              return;
            }

            // Get current date and format it
            const current_date = new Date();
            const formatted_date = current_date.getFullYear() + '-'
              + (current_date.getMonth() + 1).toString().padStart(2, '0') + '-'
              + current_date.getDate().toString().padStart(2, '0') + ' '
              + current_date.getHours().toString().padStart(2, '0') + ':'
              + current_date.getMinutes().toString().padStart(2, '0') + ':'
              + current_date.getSeconds().toString().padStart(2, '0');

            // Prepare batch data for insertion


            let insertData;

            if (selecteFilter === 'av') {

              insertData = selectedRows.map(row => ({
                device_ip: row.NetworkSettings.IPAddress,
                Device_Type: selecteFilter,
                device_id: row.ControllerId,
                ping_response: null,
                Running_status: "Running",
                device_working_status: row.Status,

                Device_location: `Room ID ${row.RoomId}`,
                Device_status: row.Status,
                created_at: formatted_date,
                updated_at: formatted_date,
                Running_at:formatted_date,
                created_by: "Admin"
              }));

            } else if (selecteFilter === 'pdu') {
              insertData = selectedRows.map(row => ({
                device_ip: row.ip_address,
                Device_Type: selecteFilter,
                device_id: row.id,
                ping_response: null,
                Running_status: "Running",
                device_working_status:row.health.overall,
                Device_location:row.location,
                Device_status: row.health.overall,
                created_at: formatted_date,
                Running_at:formatted_date,
                updated_at: formatted_date,
                created_by: "Admin"
              }));

            } else if (selecteFilter === 'network') {
              // Prepare batch data for insertion
              insertData = selectedRows.map(row => ({
                device_ip: row.HOST_IP,
                Device_Type: selecteFilter,
                device_id: 1,
                ping_response: null,
                Running_status: "Running",

                device_working_status: "Active",

                Device_location:"device",
                Device_status: "Active",
                created_at: formatted_date,
                Running_at:formatted_date,
                updated_at: formatted_date,
                created_by: "Admin"
              }));

            }
            // Prepare batch data for insertion











            // Define API request body for batch insert
            const body = {
              queryType: "batch-insert", // Use batch-insert for multiple rows
              table: "DevicesPing_Log",
              data: insertData,
            };




            

            try {
              // Call API middleware for insertion
              const response = await apiMiddleware("POST", body);

              if (response.success) {
                console.log("Batch data inserted successfully:", response.data);
              } else {
                console.error("Batch insert operation failed:", response.error);
              }
            } catch (error) {
              console.error("Error during batch insert operation:", error);
            }





          };




          insertDataIntoNotificationTbl();


          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance Started!',
              message: 'Maintenance Run Task Added'
            }
          ])


          setShowAlert(true);
        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });





    }
    else if (actionType === 'schedule') {


      let ips;


      if (selecteFilter === 'av') {
        ips = selectedRows.map((data) => data.NetworkSettings.IPAddress);

      }
      else if (selecteFilter === 'pdu') {
        ips = selectedRows.map((data) => data.ip_address);

      }
      else if (selecteFilter === 'network') {
        ips = selectedRows.map((data) => data);

      }

      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, date)
        .then(data => {


          const handleUpdate = async () => {
            // Extract HOST_IP values from State
            const hostIps = selectedRows.map((row) => row.HOST_IP); // Assuming State is an array of objects

            // Create a dynamic SQL query
            const query = `
                    UPDATE DEVICE_TBL
                    SET SHEDULE_PING_STATUS = 'Scheduled'
                    WHERE HOST_IP IN (${hostIps.map((ip) => `'${ip}'`).join(', ')})
                `;

            const body = {
              queryType: 'custom-query',
              table: 'DEVICE_TBL',
              data: {
                query: query,
              },
            };


            try {
              const response = await apiMiddleware('POST', body);
              // if (response.success) {
              //     console.log('Update successful:', response.data);
              // } else {
              //     console.error('CRUD Operation Failed:', response.error);
              // }
            } catch (error) {
              console.error('Error during CRUD operation:', error);
            } finally {
              setLoading(false); // Ensure loading is set to false after operation
            }
          };




          // handleUpdate();

          const insertDataIntoNotificationTbl = async () => {
            if (!selectedRows || selectedRows.length === 0) {
              console.error("No data to insert.");
              return;
            }


               // Get current date and format it
               const current_date = new Date();
               const formatted_date = current_date.getFullYear() + '-'
                 + (current_date.getMonth() + 1).toString().padStart(2, '0') + '-'
                 + current_date.getDate().toString().padStart(2, '0') + ' '
                 + current_date.getHours().toString().padStart(2, '0') + ':'
                 + current_date.getMinutes().toString().padStart(2, '0') + ':'
                 + current_date.getSeconds().toString().padStart(2, '0');
   
               // Prepare batch data for insertion

  let insertData;

            if (selecteFilter === 'av') {

              insertData = selectedRows.map(row => ({
                device_ip: row.NetworkSettings.IPAddress,
                Device_Type: selecteFilter,
                device_id: row.ControllerId,
                ping_response: null,
                Running_status: "Sheduled",
                device_working_status: row.Status,
                Device_location: `Room ID ${row.RoomId}`,
                Device_status: row.Status,
                created_at: formatted_date,
                updated_at: formatted_date,
                Running_at:date,
                created_by: "Admin"
              }));

            } else if (selecteFilter === 'pdu') {
              insertData = selectedRows.map(row => ({
                device_ip: row.ip_address,
                Device_Type: selecteFilter,
                device_id: row.id,
                ping_response: null,
                Running_status: "Sheduled",
                Device_location:row.location,
                device_working_status:row.health.overall,
                Device_status: row.health.overall,
                created_at: formatted_date,
                updated_at: formatted_date,
                Running_at:date,
                created_by: "Admin"
              }));

            } else if (selecteFilter === 'network') {
              // Prepare batch data for insertion
              insertData = selectedRows.map(row => ({
                device_ip: row.HOST_IP,
                Device_Type: selecteFilter,
                device_id: 1,
                ping_response: null,
                Running_status: "Sheduled",




                Device_status: "Active",
                created_at: formatted_date,
                updated_at: formatted_date,
                Running_at:date,
                created_by: "Admin"
              }));

            }
            // Prepare batch data for insertion











            // Define API request body for batch insert
            const body = {
              queryType: "batch-insert", // Use batch-insert for multiple rows
              table: "DevicesPing_Log",
              data: insertData,
            };



         
            

            try {
              // Call API middleware for insertion
              const response = await apiMiddleware("POST", body);

              if (response.success) {
                // console.log("Batch data inserted successfully:", response.data);
              } else {
                console.error("Batch insert operation failed:", response.error);
              }
            } catch (error) {
              console.error("Error during batch insert operation:", error);
            }

          





          };




          insertDataIntoNotificationTbl();






          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance scheduled!',
              message: 'Maintenance Will Run on ' + date
            }
          ])


          setShowAlert(true);

          // redirect to Notofication page
     

        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });












    }


  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [Download, setDownload] = useState('');

  
  const handleDownload = () => {
    
    setIsDialogOpen(false)
   
    
      
   
      if (Download === 'excel') {
        // Check for the 'av' filter and call ExcelDownload
        if (selecteFilter === 'av') {
          ExcelDownload({ headers: AVPDFheader, rows: selectedRows, filename: 'av-data.xlsx' });
        }

        if (selecteFilter === 'pdu') {
          ExcelDownload({ headers: PDUPDFheader, rows: selectedRows, filename: 'PDU-data.xlsx' });
        }




      }

      if (Download === 'pdf') {

        if (selecteFilter === 'av') {
        PDFDownload({ headers: AVPDFheader, rows: selectedRows,Name:"AV Devices", filename: "AV_REport.pdf" })
      }
    
      if (selecteFilter === 'pdu') {
        PDFDownload({ headers: PDUPDFheader, rows: selectedRows,Name:"PDU Devices", filename: "PDU_report.pdf" })

      }
    
    
    }
    
  };
  const FunctionBTN = (btn) => {
     if (selectedRows.length <= 0) {

      setShowAlert(true);
      setAlertData([

        {
          type: 'hold',
          title: 'No Device Selected',
          message: 'Please select at least one device to download the file.'
        }
      ])

      return;
    }
    setDownload(btn);
    setIsDialogOpen(true)
  }



   
    // Directly call the ExcelDownload function to trigger the download











  const handleSearchChange = (Data) => {

    setSearchTerm(Data);
  };






  const handleRowSelectionChange = (selectedData) => {
    setSelectedRows(selectedData);

  };




   // Filter function for both PDU and AV data
   const filteredPduData = pduData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(SearchTerm.toLowerCase())
    )
  );

  const filteredAvData = avData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(SearchTerm.toLowerCase())
    )
  );




  
 

  return (

    <>


      <Helmet>
        <title> Serco-Devices</title>
      </Helmet>
      <section className="bg-SoftBlack h-auto md:mt-0 mt-16 ">


      <ConfirmDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={handleDownload}
        title="Confirm Download"
        message="Are you sure you want to download this file?"
      />
        <MaintenancePopup heading={Heading} SheduledProcessDateTime={SheduledProcessDateTime} isOpen={isOpen} onClose={() => setIsOpen(false)} />
        {
          loading && <Loader />
        }


        {showAlert && (
          <AlertPopUP
            type={AlertData[0]?.type} // or "info" based on your needs
            title={AlertData[0]?.title}
            message={AlertData[0]?.message}
            onCloseAlert={() => setShowAlert(false) || navigate(`/Notification/${selecteFilter}`)}
          />
        )}
        <Header initialActiveButton={selecteFilter} selectedRows={selectedRows || null} HideTab={false} HideDignosticbtn={true} handleRunSelfDiagnostics={handleRunSelfDiagnostics} handleRunMaintenance={handleRunMaintenance} onButtonClick={handleonDeviceSelect} onSearchChange={handleSearchChange} HeaderBTNCLICK={FunctionBTN} />



        {selecteFilter === 'av' && (

          <>
            <TableView SHOWSETTINGTAB7={true} onRowSelectionChange={handleRowSelectionChange} headers={AVheader} rows={filteredAvData} />
          </>


        )}

        {selecteFilter === 'pdu' && (

          <>
            <TableView SHOWSETTINGTAB7={true} onRowSelectionChange={handleRowSelectionChange} headers={PDUheader} rows={filteredPduData} />
          </>


        )}

        {selecteFilter === 'network' && (

          <>
       
      
            <TableView DataAvailabe={false} SHOWSETTINGTAB7={true} onRowSelectionChange={handleRowSelectionChange} headers={PDUheader} rows={[]} />
          </>


        )}

      </section>

    </>

  );
};

export default Devices;
